module.exports = __webpack_public_path__ + "img/9788957336304.6584d5bb.jpg";